import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import assetUrl from 'src/utils/assetUrl'

const aboutNonprofit = assetUrl(RAILS_ASSET_URL('/cpwm/about-nonprofit.jpg'))

const NonprofitPanel = ({ project, charity }) =>
  <article className="d-flex flex-column min-vh-100">
    <div className="flex-fill">
      <img
        className="img-fluid w-100"
        src={aboutNonprofit}
        alt={charity.name}
      />

      <div className="t-spacing mb-auto px-3 py-4 p-sm-5 p-lg-4 p-xl-5">
        <header className="mb-5">
          <h1>
            <small className="h6 text-primary text-uppercase d-block mb-3">
              About
            </small>

            {charity.name}
          </h1>

          <hr className="border-primary hr-thicc" />
        </header>

        <div className="text-black-50">
          <p>
            Rebuilding Together believes everyone should be given the
            opportunity to live, work, and thrive in a safe place. In 1973, a
            small group of people in Midland, Texas, realized a growing need in
            their community. Homes in their community had fallen into disrepair
            and their neighbors could not afford to fix them on their own. The
            group volunteered their time and skills to rehabilitate the homes of
            their neighbors. Realizing the potential impact of this work, the
            group formed Christmas in April, with the intent of performing
            repair and rehabilitation work in their community every April.
          </p>

          <p>
            News of the group’s good work spread slowly, but eventually achieved
            national recognition. The mission spread beyond the idea of
            providing service once a year in April to bringing together partners
            from all walks of life to help our neighbors year-round. They opened
            the national office in 1988 and became Rebuilding Together.
          </p>

          <p>
            Today, Rebuilding Together has grown into a premier nonprofit
            community revitalization organization. Rebuilding Together’s local
            affiliates and nearly 100,000 volunteers complete about 10,000
            rebuild projects nationwide each year.
          </p>
        </div>
      </div>
    </div>

    { charity.url ?
      <a
        className="d-block bg-light text-body text-uppercase font-weight-bold t-spacing px-3 py-4 p-sm-5 p-lg-4 p-xl-5"
        href={charity.url}
        target="_blank"
      >
        {charity.text}
        <FontAwesomeIcon icon="external-link-alt" className="ml-2" />
      </a>
      : null
    }
  </article>

export default NonprofitPanel
